import React, { ReactNode } from 'react';
import classNames from 'classnames';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  backButton?: ReactNode;
  className?: string;
}

/**
 * PageHeader component for consistent page headers
 */
const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  backButton,
  className = '',
}) => {
  return (
    <div className={classNames('mb-6', className)}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center">
          {backButton && <div className="mr-3">{backButton}</div>}
          <h1 className="text-2xl font-bold">{title}</h1>
        </div>
        {actions && <div className="flex items-center space-x-2">{actions}</div>}
      </div>
      {subtitle && <p className="text-gray-600 dark:text-gray-400">{subtitle}</p>}
    </div>
  );
};

export default PageHeader;